import { Badge } from "@/components/badge";
import { getStatusColor } from "@/features/shared/constants/statusColors";

interface Status {
  id: number;
  name: string;
}

interface RequestStatusBadgeProps {
  status: Status;
}

export function RequestStatusBadge({ status }: RequestStatusBadgeProps) {
  const color = getStatusColor(status.id);

  return (
    <Badge
      className="inline-flex justify-center whitespace-nowrap"
      isRounded
      size="small"
      variant={color}
    >
      {status.name}
    </Badge>
  );
}
